module.exports = __webpack_public_path__ + "media/images/missing/default-7e16995c89f53a9946f52dc76c1d807b.png";